import { Component } from '@angular/core';
import { ObjectWidget as _ObjectWidget, FormProperty } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-form-object',
  templateUrl: './object.widget.html',
} )
export class ObjectWidget extends _ObjectWidget {
  schema: JSONSchema;

  isPropertyVisible( path: string ) {
    return ( <FormProperty>this.formProperty.getProperty( path ) ).visible;
  }

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/object.widget.ts